import { Grid, Typography, Button, Box, Paper, SvgIcon } from "@mui/material";
import Empty_Wishlist_img from "../../../assets/SAP-Dashboard/Wishlist/EmptyWishlist.png";
import { motion } from "framer-motion";
import { FaStar, FaBook, FaHeart } from "react-icons/fa";

const FloatingIcon = ({ Icon, delay, left }) => (
  <motion.div
    style={{
      position: "absolute",
      bottom: 0,
      left,
      color: "#9D0385",
      fontSize: "20px",
    }}
    animate={{
      y: [0, -500],
      opacity: [1, 0],
    }}
    transition={{
      duration: 9,
      repeat: Infinity,
      repeatType: "loop",
      delay,
      ease: "linear",
    }}
  >
    <Icon />
  </motion.div>
);

const EmptyWishlist = () => {
  const handleExploreCourses = () => {
    console.log("Navigate to courses page");
  };

  return (
    <Paper
      elevation={3}
      sx={{
        position: "relative",
        background: "#FFFFFF",
        borderRadius: 4,
        p: { xs: 4, md: 8 },
        maxWidth: 900,
        mx: "auto",
        minHeight: 400,
        overflow: "hidden",
        display: "flex", 
        alignItems: "center", 
        justifyContent: "center", 
      }}
    >
      {/* Decorative Circles */}
      <Box
        sx={{
          position: "absolute",
          top: -50, // half outside
          left: -50, // half outside
          width: 120,
          height: 120,
          borderRadius: "50%",
          backgroundColor: "#9D03850F",
        }}
      />
      {/* Floating Icons */}
      <FloatingIcon Icon={FaStar} delay={0} left="20%" />
      <FloatingIcon Icon={FaBook} delay={1} left="50%" />
      <FloatingIcon Icon={FaHeart} delay={2} left="75%" />
      <Box
        sx={{
          position: "absolute",
          bottom: -50,
          right: -50,
          width: 160,
          height: 160,
          borderRadius: "50%",
          backgroundColor: "#9D03850F",
        }}
      />

      {/* Centered content */}
      <Grid
        container
        spacing={2}
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ zIndex: 2 }} 
      >
        {/* Heart Icon */}
        <Grid item>
          <svg
            width="94"
            height="94"
            viewBox="0 0 94 94"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="47" cy="47" r="47" fill="#9D0385" fill-opacity="0.06" />
            <path
              d="M61.2775 34.0674C59.4196 32.2089 56.9563 31.079 54.3357 30.8831C51.7151 30.6872 49.1112 31.4383 46.9975 32.9999C44.7709 31.3438 41.9995 30.5928 39.2414 30.8982C36.4833 31.2037 33.9433 32.5428 32.133 34.6459C30.3227 36.7491 29.3765 39.4601 29.485 42.2329C29.5934 45.0058 30.7485 47.6346 32.7176 49.5899L45.755 62.6274C45.9177 62.7914 46.1113 62.9216 46.3245 63.0105C46.5378 63.0993 46.7665 63.1451 46.9975 63.1451C47.2286 63.1451 47.4573 63.0993 47.6706 63.0105C47.8838 62.9216 48.0774 62.7914 48.24 62.6274L61.2775 49.5899C62.2972 48.5709 63.1061 47.361 63.6579 46.0293C64.2098 44.6976 64.4938 43.2702 64.4938 41.8287C64.4938 40.3871 64.2098 38.9597 63.6579 37.628C63.1061 36.2963 62.2972 35.0864 61.2775 34.0674ZM58.81 47.1224L46.9975 58.9174L35.1851 47.1224C34.1441 46.0771 33.435 44.7477 33.1467 43.301C32.8584 41.8543 33.0037 40.3546 33.5645 38.9902C34.1252 37.6257 35.0764 36.4572 36.2987 35.6313C37.5209 34.8053 38.9599 34.3587 40.435 34.3474C42.4057 34.3522 44.294 35.139 45.685 36.5349C45.8477 36.6989 46.0413 36.8291 46.2545 36.918C46.4678 37.0068 46.6965 37.0526 46.9275 37.0526C47.1586 37.0526 47.3873 37.0068 47.6006 36.918C47.8138 36.8291 48.0074 36.6989 48.17 36.5349C49.6021 35.294 51.4522 34.6434 53.3457 34.715C55.2393 34.7865 57.035 35.5748 58.3694 36.9202C59.7037 38.2657 60.4771 40.0679 60.5329 41.962C60.5887 43.8561 59.9228 45.7007 58.67 47.1224H58.81Z"
              fill="#9D0385"
            />
          </svg>
        </Grid>

        {/* Heading */}
        <Grid item>
          <Typography
            align="center"
            sx={{
              fontFamily: "Inters, sans-serif",
              fontWeight: 700,
              fontSize: "24px",
              lineHeight: "100%",
              color: "#9D0385",
            }}
          >
            Your Wishlist is empty
          </Typography>
        </Grid>

        {/* Description */}
        <Grid item>
          <Typography
            align="center"
            sx={{
              fontFamily: "Inter, sans-serif",
              fontWeight: 400,
              fontSize: "21px",
              lineHeight: "100%",
              color: "#555555",
              maxWidth: 750,
              mx: "auto",
            }}
          >
            You haven't added any Course to your wishlist yet. Explore our
            courses and add your favorites to compare them later.
          </Typography>
        </Grid>

        {/* Button */}
        <Grid item pb={10}>
          <Button
            href="/sap/courses"
            variant="contained"
            onClick={handleExploreCourses}
            sx={{
              borderRadius: 2,
              px: 4,
              py: 1.5,
              fontWeight: 600,
              backgroundColor: "#9D0385",
              "&:hover": { backgroundColor: "#9D0385" },
            }}
            startIcon={
              <svg
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.5002 17.9999L13.881 14.3808M13.881 14.3808C14.5001 13.7617 14.9912 13.0267 15.3262 12.2179C15.6612 11.409 15.8337 10.5421 15.8337 9.66659C15.8337 8.79109 15.6612 7.92416 15.3262 7.11531C14.9912 6.30645 14.5001 5.5715 13.881 4.95243C13.2619 4.33335 12.527 3.84228 11.7181 3.50724C10.9093 3.1722 10.0423 2.99976 9.16684 2.99976C8.29134 2.99976 7.42441 3.1722 6.61555 3.50724C5.80669 3.84228 5.07174 4.33335 4.45267 4.95243C3.2024 6.2027 2.5 7.89844 2.5 9.66659C2.5 11.4347 3.2024 13.1305 4.45267 14.3808C5.70295 15.631 7.39868 16.3334 9.16684 16.3334C10.935 16.3334 12.6307 15.631 13.881 14.3808Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            }
          >
            Explore Courses
          </Button>
        </Grid>
      </Grid>

      {/* Illustration fixed at bottom-left */}
      <Grid
        container
        justifyContent="flex-start"
        alignItems="flex-end"
        sx={{
          position: "absolute",
          bottom: -95,
          left: 0,
          height: "100%",
          width: "100%",
          pointerEvents: "none",
        }}
      >
        <Grid
          item
          sx={{
            display: { xs: "none", md: "block" },
            pb: 2,
            pl: 2,
          }}
        >
          <Box
            component="img"
            src={Empty_Wishlist_img}
            alt="Wishlist Illustration"
            sx={{
              width: 200,
              height: 300,
              objectFit: "contain",
            }}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default EmptyWishlist;
